// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pdfViewer":"fL4Imr","close":"_1P22Eo"};